import React from 'react';
import './Task.css';

function Task(props) {
    return (
        <div className='task'>
            <li className='text text-left'>
                {props.task}
                <button className='button btn btn-danger' onClick={() => props.onDeleteTask(props.id)}>X</button>
            </li>
        </div>
    );
}

export default Task;